import type { AppointmentType } from "../../types/types.ts"

// Hand-mirrored: the same set lives in ezbuild_back (MeetingCategory) and in
// mobile (TCalendarApiEventCategory). Neither side can fail this build.
export const APPOINTMENT_TYPES = [
  "LEAD_MEETING",
  "SITE_VISIT",
  "INSPECTION",
  "PROPOSAL",
  "PROJECT_MEETING",
  "REMINDER",
  "PERSONAL",
  "FOLLOW_UP"
] as const satisfies readonly AppointmentType[]

// Not dead code: fails the build when the AppointmentType union gains a member
// this list does not. Erased at compile time.
type AssertNever<T extends never> = T
export type AppointmentTypeExhaustiveCheck = AssertNever<
  Exclude<AppointmentType, (typeof APPOINTMENT_TYPES)[number]>
>

// REMINDER is absent on purpose: the Event/Reminder toggle has already set the
// type before this form opens, so offering it here would allow type=EVENT with
// category=REMINDER — a pair mobile cannot produce.
export const EVENT_FORM_APPOINTMENT_TYPES = [
  "LEAD_MEETING",
  "SITE_VISIT",
  "PROPOSAL",
  "PROJECT_MEETING",
  "INSPECTION",
  "PERSONAL",
  "FOLLOW_UP"
] as const satisfies readonly AppointmentType[]

export const APPOINTMENT_TYPES_REQUIRING_TIME = [
  "LEAD_MEETING",
  "PROJECT_MEETING",
  "FOLLOW_UP"
] as const satisfies readonly AppointmentType[]

export const appointmentTypeLabelKey = (value: AppointmentType): string =>
  `appointmentType.${value.toLowerCase()}`
